import { animate } from 'framer-motion';
import { lockBodyScroll, unlockBodyScroll } from '@/shared/lib/utils/dom';
import { easeInOutCubic } from '@/shared/lib/utils/easings';
import { timeout } from '../lib/utils/timeout';

export const leaveDefault = ({
    setOpenedPopups,
}: {
    targetElement?: Element | null;
    setOpenedPopups?: (popups: string[]) => void;
}): Promise<void> =>
    new Promise((resolve) => {
        const whiteBg = document.querySelector<HTMLElement>('.js-transition-white-bg');
        const blueBg = document.querySelector<HTMLElement>('.js-transition-blue-bg');

        lockBodyScroll();
        if (whiteBg && blueBg) {
            if (setOpenedPopups) {
                setOpenedPopups([]);
            }
            animate(0, 1, {
                duration: 0.8,
                ease: easeInOutCubic,
                onUpdate: (val) => {
                    blueBg.style.transform = `scaleX(${val})`;
                },
                onComplete: () => {
                    blueBg.style.transformOrigin = 'right';
                    blueBg.style.left = 'unset';
                    blueBg.style.right = '0';
                    animate(1, 0, {
                        duration: 0.8,
                        ease: easeInOutCubic,
                        onUpdate: (val) => {
                            blueBg.style.transform = `scaleX(${val})`;
                        },
                        onComplete: () => {
                            blueBg.style.transformOrigin = 'left';
                            blueBg.style.transform = ``;
                            blueBg.style.left = '0';
                            blueBg.style.right = 'unset';
                        },
                    });
                },
            });
            animate(0, 1, {
                duration: 0.8,
                delay: 0.2,
                ease: easeInOutCubic,
                onUpdate: (val) => {
                    whiteBg.style.transform = `scaleX(${val})`;
                },
                onComplete: async () => {
                    whiteBg.style.transformOrigin = 'right';
                    whiteBg.style.left = 'unset';
                    whiteBg.style.right = '0';
                    resolve();
                    await timeout(100);
                    unlockBodyScroll();
                    animate(1, 0, {
                        duration: 0.8,
                        ease: easeInOutCubic,
                        onUpdate: (val) => {
                            whiteBg.style.transform = `scaleX(${val})`;
                        },
                        onComplete: () => {
                            whiteBg.style.transformOrigin = 'left';
                            whiteBg.style.transform = ``;
                            whiteBg.style.left = '0';
                            whiteBg.style.right = 'unset';
                        },
                    });
                },
            });
        } else {
            unlockBodyScroll();
            resolve();
        }
    });
